// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6392":"b984105f","6976":"b83499bd"}[chunkId] + ".chunk.css";
};